<template>
  <v-app class="grey lighten-3" v-if="isLoggedIn">
    <v-layout>
      <v-flex xs12 sm12 md12 row>
        <v-container grid-list-md>
          <v-card>
            <v-card-title class="project">
              <div class="white--text headline">
                <span class="headline">Dasher Cash Out Report</span>
              </div>
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout wrap>
                  <v-flex xs4 sm4 md4>
                    <v-select
                      v-model="filterItem.withdraw_status"
                      :rules="transaction_rules"
                      :items="withdraw_status_array"
                      item-text="text"
                      item-value="value"
                      box
                      label="Transaction Type"
                    ></v-select>
                  </v-flex>

                  <v-flex xs4 sm4 md4>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterItem.date_from"
                          :rules="dateFrom"
                          box
                          label="Date From *"
                          readonly
                          outlined
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="filterItem.date_from"
                        @change="save(date)"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <v-menu
                      ref="menu"
                      v-model="menu1"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filterItem.date_to"
                          :rules="dateTo"
                          box
                          label="Date To *"
                          readonly
                          outlined
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="filterItem.date_to"
                        @change="save(date)"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="button" color="info" flat @click="submit"
                >Show</v-btn
              >
            </v-card-actions>
          </v-card>
          <v-card style="margin-top: 5px" v-if="isClicked">
            <v-card-text v-if="isLoaded">
              <v-toolbar flat color="gray">
                 <v-toolbar-title>Date From {{ filterItem.date_from }} To {{ filterItem.date_to }} {{ getDataType() }} Data</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  align="center"
                ></v-text-field>
              </v-toolbar>

              <div v-if="indexData.dasherCashOutReport.length < 1" class="text-xs-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
              <v-data-table
                :headers="headers"
                :items="indexData.dasherCashOutReport"
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <td>{{ props.item.transaction_id }}</td>
                  <td>{{ props.item.transaction_date }}</td>
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.account_number }}</td>
                  <td>{{ props.item.wallet_type }}</td>
                  <td>
                    {{ props.item.first_name }} {{ props.item.middle_name }}
                    {{ props.item.last_name }}
                  </td>
                  <td> {{ props.item.user_id }} </td>
                  <td>N/A</td>
                  <td>{{ props.item.amount_coin }}</td>
                  <td>{{ props.item.withdraw_amount }}</td>
                  <td>{{ props.item.remaining_coin }}</td>
                  <td>{{ props.item.remaining_amount }}</td>
                </template>
              </v-data-table>
            </v-card-text>
             <v-card-text v-else>
               No Data Found
             </v-card-text>
              <v-spacer></v-spacer>
              <v-btn class="button" color="info" flat @click="download" v-if="isLoaded"
                >Download</v-btn
              >
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
  <v-layout v-else>
    <Signin class="mt-1"></Signin>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    menu: false,
    menu1: false,
    menu2: false,
    date: null,
    apiUrl: "dasher-daily-cash-out-report",
    editedIndex: -1,
    isClicked: false,
    dialog: false,
    search: "",
    projectId: "",
    transaction_status_id: "",

    filterItem: {
      withdraw_status: "",
      date_from: "",
      date_to: "",
    },
    withdraw_status_array: [
      { text: "Pending", value: "1" },
      { text: "Accepted", value: "2" },
      { text: "Disbursed", value: "4" },
      { text: "All", value: "0" },
    ],
    valid: true,
    headers: [
     
      { text: "Transaction ID", value: "transaction_id" },
      { text: "Transaction Date", value: "transaction_date" },
      { text: "Cash Out Request ID", value: "id" },
      { text: "Cash Out Details", value: "wallet_type" },
      { text: "Reference", value: "wallet_type" },
      { text: "Dasher Name", value: "first_name" },
      { text: "Dasher ID", value: "user_id" },
      { text: "Team Code", value: "id" },
      { text: "Coins Cash Out", value: "amount_coin" },
      { text: "Taka Cash Out", value: "withdraw_amount" },
      { text: "Dasher Coin Balance", value: "remaining_coin" },
      { text: "Dasher Taka Balance", value: "remaining_amount" },
    ],
    transaction_rules: [(v) => !!v || "Transaction Type is required"],
    dateFrom: [(v) => !!v || "Date From is required"],
    dateTo: [(v) => !!v || "Date From is required"],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    isLoaded() {
      if (this.indexData.dasherCashOutReport) {
        return true;
      } else {
        return false;
      }
    },
    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "DATE"));
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      if (this.isClicked) {
        this.$store.dispatch("getCashOutReport", [this.apiUrl, this.filterItem.withdraw_status, this.filterItem.date_from,this.filterItem.date_to]);
      }
      // console.log(this.withdraw_status_array);
    },
    save(date) {
      this.$refs.menu.save(date);
      this.menu = false;
    },
    getDataType: function(){
      if(this.filterItem.withdraw_status == '0'){
        return "All";
      }
      else if(this.filterItem.withdraw_status == '1'){
        return "Pending";
      }
      else if(this.filterItem.withdraw_status == '2'){
        return "Accepted";
      }
      else if(this.filterItem.withdraw_status == '4'){
        return "Disbursed";
      }
      
    },
    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },
    getTaka: function (coins) {
      return coins / 10;
    },
    getTakaBeforeTransaction: function (balance, withdraw) {
      return balance + withdraw;
    },
    getCoinsBeforeTransaction: function (balance, withdraw) {
      return balance + withdraw;
    },
    close() {
      setTimeout(() => {
        this.budget = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    download(){
      window.open(this.indexData.excelUrl);
    },

    submit() {
      // console.log(this.editedItem)
      if (this.$refs.form.validate()) {
        this.isClicked = true;
        // console.log(this.filterItem);
        this.$store.dispatch("getCashOutReport", [this.apiUrl, this.filterItem.withdraw_status, this.filterItem.date_from,this.filterItem.date_to]);
        //
      }
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.no-upercase {
  text-transform: unset !important;
}
.text_color {
  color: white;
}
.project {
  background: #ff2e2e;
}
::v-deep ::-webkit-scrollbar {
  width: 0;
}
</style>
